import { useProvider } from "@/features/providers/api/get-provider";
import { useProviders } from "@/features/providers/api/get-providers";
import useQueryParams from "@/hooks/use-query-params";
import { useMcpProvider, VIA_NEXUS_PROVIDER } from "@/providers/mcp-providers-context";
import { useBrandingHorizontalLogos } from "@/hooks/use-branding-horizontal-logos";
import { getUiBranding } from "@blueskydataplatform/shared-ui/theme/ui-branding";
import { useEffect } from "react";

const InitProvider = () => {
  const { setProvider } = useMcpProvider();

  const { isFromMCP, provider: queryProvider } = useQueryParams();
  const { data: providers, isLoading } = useProviders();
  const { data: provider, isLoading: isProviderLoading } = useProvider({ providerId: queryProvider });
  const branding = getUiBranding();
  const brandingLogos = useBrandingHorizontalLogos(branding);

  useEffect(() => {
    if (isFromMCP) {
      if (isLoading || isProviderLoading) {
        setProvider(null);
        return;
      }

      if (provider) {
        setProvider(provider);
        return;
      }

      if (providers) {
        const defaultProvider = providers.find(p => p.mcp?.isDefaultProvider);
        if (defaultProvider) {
          setProvider(defaultProvider);
          return;
        }
      }
    }

    const brandingLogo = {
      light: brandingLogos.lightSrc || VIA_NEXUS_PROVIDER.logo?.light || "",
      dark: brandingLogos.darkSrc || VIA_NEXUS_PROVIDER.logo?.dark || "",
      altText: brandingLogos.lightAlt || brandingLogos.darkAlt || VIA_NEXUS_PROVIDER.logo?.altText || "",
    };
    setProvider({ ...VIA_NEXUS_PROVIDER, logo: brandingLogo });
  }, [provider, providers, setProvider, isFromMCP, isLoading, isProviderLoading, brandingLogos]);

  return null;
};

export default InitProvider;
